 
import { useRef, useState, useEffect } from "react";

const HEADER_HEIGHT = 70; // Customize this as needed

const ManualTooltip = ({ children, content }) => {
  const iconRef = useRef(null);
  const tooltipRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState("top-right");

  const calculatePosition = () => {
    const icon = iconRef.current;
    const tooltip = tooltipRef.current;
    if (!icon || !tooltip) return;

    const iconRect = icon.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const padding = 10;

    const space = {
      top: iconRect.top,
      bottom: window.innerHeight - iconRect.bottom,
      left: iconRect.left,
      right: window.innerWidth - iconRect.right,
    };

    // Priority: bottom-right > bottom-left > top-right > top-left
    if (space.bottom >= tooltipRect.height + padding && space.right >= tooltipRect.width + padding) {
      setPosition("bottom-right");
    } else if (space.bottom >= tooltipRect.height + padding && space.left >= tooltipRect.width + padding) {
      setPosition("bottom-left");
    } else if (space.top >= tooltipRect.height + padding && space.right >= tooltipRect.width + padding) {
      setPosition("top-right");
    } else if (space.top >= tooltipRect.height + padding && space.left >= tooltipRect.width + padding) {
      setPosition("top-left");
    } else {
      // Fallback: pick the side with the most space
      const maxSpace = Math.max(space.bottom, space.top, space.right, space.left);
      if (maxSpace === space.bottom) {
        setPosition(space.right > space.left ? "bottom-right" : "bottom-left");
      } else if (maxSpace === space.top) {
        setPosition(space.right > space.left ? "top-right" : "top-left");
      } else if (maxSpace === space.right) {
        setPosition(space.bottom > space.top ? "bottom-right" : "top-right");
      } else {
        setPosition(space.bottom > space.top ? "bottom-left" : "top-left");
      }
    }
  };

  useEffect(() => {
    if (visible) {
      setTimeout(calculatePosition, 0);
    }
  }, [visible]);


  return (
    <div
      className="tooltip-wrapper"
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}

    >
      <div ref={iconRef}>{children}</div>
      {visible && (
        <div
          ref={tooltipRef}
          className={`tooltip-box ${position}`}
          style={{
            position: "absolute",
            zIndex: 9999,
            whiteSpace: "normal",
            overflowWrap: "break-word",
            ...getTooltipStyle(position),
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

function getTooltipStyle(position) {
  switch (position) {
    case "top-right":
      return { bottom: "100%", left: "0", marginBottom: "8px" };
    case "top-left":
      return { bottom: "100%", right: "0", marginBottom: "8px" };
    case "bottom-right":
      return { top: "100%", left: "0", marginTop: "8px" };
    case "bottom-left":
      return { top: "100%", right: "0", marginTop: "8px" };
    default:
      return {};
  }
}

export default ManualTooltip;